import React, { useState } from 'react'
import { Element, ElementTitle } from '../styled';
import { useForm, useFetch } from '../../../../../hooks';
import FromSelect from '../../../../../components/inputs/FromSelect';
import Buttons from '../../../../../modules/Buttons';
import Button from '../../../../../components/inputs/Button';
import { CardItem } from '../../../../../components/Card';
import CardSection from '../../../../../components/Card/CardSection';
import { prop, pathOr, defaultTo, compose, map } from 'ramda';

const Timezone = ({ data, refetchAccount }) => {
    const { fetching, doFetch } = useFetch({
        url: `/rpc/set_timezone`,
        method: 'POST'
    })

    const { response: resTimezones } = useFetch({
        url: `/rpc/get_timezones`,
        method: 'POST',
        lazy: false,
        loader: false
    })

    const [isEditMode, setEditMode] = useState(false);

    const save = async values => {
        //TODO example for error handling
        try {
            const response = await doFetch({
                data: values
            })
            if (response === 1) {
                setEditMode(false);
                refetchAccount();
            } else {
                throw Error(response);
            }
        } catch (error) {
            console.log(error);
        }
    }

    const { values, errors, handleChange, handleSubmit } = useForm({
        callback: save,
        initValues: {
            tzone: pathOr(null, ["data"], data)
        }
    })

    const handleClickEdit = () => setEditMode(true);
    const handleClickCancel = () => setEditMode(false);

    return (
        <CardSection>
            {
                isEditMode ?
                    (
                        <form onSubmit={handleSubmit}>
                            <Element>
                                <ElementTitle>{pathOr("", ["title"], data)}</ElementTitle>
                                <FromSelect
                                    name='tzone'
                                    onChange={handleChange}
                                    value={values['tzone'].toString()}
                                    error={errors['tzone']}
                                    options={compose(
                                        map(option => ({ value: option, label: option })),
                                        defaultTo([]),
                                        prop('data')
                                    )(resTimezones)}
                                    noMargin
                                />
                            </Element>
                            <Buttons stretch>
                                <Button
                                    type="button"
                                    width="48%"
                                    onClick={handleClickCancel}
                                >
                                    {pathOr("", ["buttons", "cancel"], data)}
                                </Button>
                                <Button
                                    type="submit"
                                    green
                                    width="48%"
                                    disabled={fetching}
                                >
                                    {pathOr("", ["buttons", "save"], data)}
                                </Button>
                            </Buttons>
                        </form>
                    )
                    :
                    (
                        <>
                            <CardItem
                                left={{
                                    name: pathOr("", ["title"], data),
                                    value: pathOr("", ["data"], data)
                                }}
                            />
                            <Button
                                type="button"
                                green
                                fullWidth
                                onClick={handleClickEdit}
                            >
                                {pathOr("", ["buttons", "edit"], data)}
                            </Button>
                        </>
                    )
            }
        </CardSection>
    )
}

export default Timezone
